import React from 'react';
import { BaseMapView } from './base-map-view';
import { Region } from './types';

interface Props {
  animateToRegion?: Region;
  children: React.ReactNode;
  initialRegion: Region;
}

export const StaticMapView: React.FC<Props> = ({
  animateToRegion,
  children,
  initialRegion,
}) => {
  return (
    <>
      <BaseMapView
        animateToRegion={animateToRegion}
        initialRegion={initialRegion}
        interactive={false}
      >
        {children}
      </BaseMapView>
    </>
  );
};
